
import Constants from '../constants';
import produce from "immer";
import { UpdateArray, UpdateArrayRange } from '../misc/ArrayFuncs';
const constants=Constants
const roundToTwo = (num) => {
    return +(Math.round(num + "e+2") + "e-2");
}
const initDataState = [];
const GlueLineMachines = (state = initDataState, action) => {
    switch (action.type) {
        case constants.Actions.GlueLineMachine.Add:
            return UpdateArray(action.payload, state);
        case constants.Actions.GlueLineMachine.Add_Rollback:
            const ivId = state.findIndex(iv => iv.id === action.meta.newGLM.id);
            if (ivId !== -1) {
                return produce(state, pd => { pd.splice(ivId, 1) });
            } else {
                return state;
            }
        case constants.Actions.GlueLineMachine.Add_Commit:
            return UpdateArray(action.payload?.data, state);
        case constants.Actions.GlueLineMachine.ClearData:
            return initDataState;
        case constants.Actions.GlueLineMachine.Update:
            //Action will have the full plant data
            return state.map((p, ind) => {
                if (p.id === action.payload.id) {
                    return produce(p, pd => { pd[action.payload.name] = action.payload.newValue });
                } else { return p; }
            });

        case constants.Actions.GlueLineMachine.Update_Commit:
            return UpdateArray(action.payload?.data, state);
        case constants.Actions.GlueLineMachine.Update_Rollback:
            //Action will have the full plant data
            return state.map((p, ind) => {
                if (p.id === action.meta.updatePayload.id) {
                    return produce(p, pd => { pd[action.meta.updatePayload.name] = action.meta.updatePayload.oldValue });
                } else { return p; }
            });
        case constants.Actions.GlueLineMachine.GetByParentID:
            return UpdateArrayRange(action.data, state);
        default:
            return state;
    }
}
export default GlueLineMachines;